import { p as palette } from '../base/color-ec580bc4.js';

// eslint-disable-next-line import/prefer-default-export
const icon = {
  color: palette.gray[700],
  hover: {
    color: palette.squidInk
  }
};

export { icon as i };
//# sourceMappingURL=icon-14b0913e.js.map
